import { fetchReasons, fetchExemptionRenewReasons, fetchCivilities } from '../../service/api/exemptions.api';

const state = {
    contractTypes: [],
    createLegalInformation: null,
    baseReasonsCache: {},
    baseReasons: [],
    exemptionRenewReasons: [],
    civilities: []
};

const mutations = {
    'SET_CONTRACT_TYPES' (state, contractTypes) {
        state.contractTypes = contractTypes;
    },
    'SET_CREATE_LEGAL_INFORMATION' (state, legalInformation) {
        state.createLegalInformation = legalInformation;
    },
    'SET_BASE_REASONS' (state, reasons) {
        state.baseReasons = reasons;
    },
    'SET_BASE_REASONS_CACHE' (state, { enterpriseUuid, reasons }) {
        state.baseReasonsCache = { ...state.baseReasonsCache, [enterpriseUuid]: reasons };
        state.baseReasons = reasons;
    },
    'SET_EXEMPTION_RENEW_REASONS' (state, exemptionRenewReasons) {
        state.exemptionRenewReasons = exemptionRenewReasons;
    },
    'SET_CIVILITIES' (state, civilities) {
        state.civilities = civilities;
    }
};

const actions = {
    async fetchBaseReasons({ commit, state }, enterpriseUuid) {
        if (state.baseReasonsCache[enterpriseUuid]) {
            commit('SET_BASE_REASONS', state.baseReasonsCache[enterpriseUuid]);
            return;
        }

        let { data } = await fetchReasons({ params: { enterpriseUuid, 'isOptional': false } });
        commit('SET_BASE_REASONS_CACHE', { enterpriseUuid, reasons: data });
    },
    async fetchExemptionRenewReasons({ commit }, { exemptionId, enterpriseUuid }) {
        let { data } = await fetchExemptionRenewReasons(exemptionId, { params: { 'isOptional': false, enterpriseUuid } });
        commit('SET_EXEMPTION_RENEW_REASONS', data);
    },
    async fetchCivilities({ commit, state }) {
        if (state.civilities && state.civilities.length > 0) {
            return;
        }

        const { data } = await fetchCivilities();
        commit('SET_CIVILITIES', data);
    }
};

const getters = {
    contractTypes: state => state.contractTypes,
    createLegalInformation: state => state.createLegalInformation,
    baseReasons: state => state.baseReasons,
    filteredBaseReasons: state => {
        return state.baseReasons.filter((reason) => {
            return reason.code !== 'cd7';
        });
    },
    exemptionRenewReasons: state => state.exemptionRenewReasons,
    filteredExemptionRenewReasons: state => {
        return state.exemptionRenewReasons.filter((reason) => {
            return reason.code !== 'cd7';
        });
    },
    civilities: state => state.civilities
};

export default {
    state,
    mutations,
    actions,
    getters
};
